import { LanguageToggle } from '@ui/language-toggle'
import { ThemeToggle } from '@ui/theme-toggle'
import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router'
import { I18N_URL_PARAM_KEY } from '@/constants/i18n'
import { i18n } from '@/i18n'
import { normalizeLanguage } from '@/utils/i18n'

export const RootLayout = () => {
  const location = useLocation()

  // 监听 URL 参数变化，更新语言
  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const lang = params.get(I18N_URL_PARAM_KEY)
    if (lang) {
      const normalizedLang = normalizeLanguage(lang)
      if (i18n.language !== normalizedLang) {
        i18n.changeLanguage(normalizedLang)
      }
    }
  }, [location.search])

  return (
    <div className='min-h-screen bg-white dark:bg-gray-900 transition-colors duration-200'>
      <div className='fixed top-4 right-4 z-50 flex items-center gap-2'>
        <LanguageToggle />
        <ThemeToggle />
      </div>

      <Outlet />
    </div>
  )
}
